import React, { useState } from 'react';
import { LEADS } from '../../constants/columns';
import MOCK_DATA from '../../MOCK_DATA.json';
import { useTable, useGlobalFilter, usePagination, useSortBy } from 'react-table';
import { leadsOptions } from '../../constants/filterOptions';
import { useNavigate } from 'react-router-dom';
import axios from '../../plugins/axios';
import { setFilters } from '../../utils/setFilters';
import describeFilters from '../../utils/describeFilters';
import useTableUrlSync, { useInitialTableQuery } from '../../hooks/useTableUrlState';
import { saveFilterSnapshot, clearFilterSnapshot, readFilterValues } from '../../utils/filterSnapshot';
import { sortLeadsParams } from '../../constants/sortParams';

// components
import Header from '../../components/Header/Header';
import Table from '../../components/Table/Table';
import Empty from '../../components/Empty/Empty';
import TableTabs from '../../components/TableTabs/TableTabs';
import ClientPopup from '../../components/ClientPopup/ClientPopup';
import HookForm from '../../components/HookForm/HookForm';
import EditLeadModal from '../../components/Modals/EditLeadModal';
import SelectManager from '../../components/Selects/SelectManager';

// icons
import icon from '../../brand/generated/sidebar/leads.svg';
import eye from '../../brand/generated/popover/eye.svg';
import bucket from '../../brand/generated/popover/delete.svg';
import edit from '../../brand/generated/popover/edit.svg';
import set from '../../brand/generated/popover/set.svg';
import { PERMISSION_CAN_CREATE_LEADS } from '../../constants/roles';

// minWidth â ÑÑÐ¾Ð±Ñ Ð½Ð° ÑÐ·ÐºÐ¾Ð¼ ÑÐºÑÐ°Ð½Ðµ ÑÐ°Ð±Ð»Ð¸ÑÐ° ÑÐºÑÐ¾Ð»Ð»Ð¸Ð»Ð°ÑÑ (Ð¾Ð±ÑÑÑÐºÐ° ÑÐ¶Ðµ Ñ overflow-x),
// Ð° Ð½Ðµ ÑÐ¶Ð¸Ð¼Ð°Ð»Ð° ÐºÐ¾Ð»Ð¾Ð½ÐºÐ¸ Ð´Ð¾ Ð½ÐµÑÐ¸ÑÐ°ÐµÐ¼Ð¾Ð³Ð¾ ÑÐ¾ÑÑÐ¾ÑÐ½Ð¸Ñ. Ð¢Ð°Ðº Ð¶Ðµ ÑÐ´ÐµÐ»Ð°Ð½Ð¾ Ð² Clients.
const tableStyle = { backgroundColor: 'white', minWidth: 1550 };

const popover = [
  { title: 'ÐÑÐ¾ÑÐ¼Ð¾ÑÑÐµÑÑ Ð»Ð¸Ð´', icon: eye },
  { title: 'Ð ÐµÐ´Ð°ÐºÑÐ¸ÑÐ¾Ð²Ð°ÑÑ Ð»Ð¸Ð´', icon: edit },
  { title: 'ÐÐ°Ð·Ð½Ð°ÑÐ¸ÑÑ Ð¾ÑÐ²ÐµÑÑÑÐ²ÐµÐ½Ð½Ð¾Ð³Ð¾', icon: set },
  { title: 'Ð£Ð´Ð°Ð»Ð¸ÑÑ Ð»Ð¸Ð´', icon: bucket },
];

const formStyles = {
  record: { display: 'grid', gap: '20px', gridTemplateAreas: `'a a k k' 'b b b b' 'c c v v' 'd d d d' 'f f f f'` },
};

const FILTER_NAMES = [...leadsOptions.map((option) => option.name), 'all'];
const SNAPSHOT_KEY = 'leads';

const Leads = () => {
  const [columns, setColumns] = React.useState(LEADS);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [leads, setLeads] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const fromUrl = useInitialTableQuery(FILTER_NAMES);
  const [queryParams, setQueryParams] = useState(fromUrl.filters);
  const [pagination, setPagination] = useState({
    page: fromUrl.page,
    totalPages: 1,
    hasPreviousPage: false,
    hasNextPage: false,
    pageSize: fromUrl.pageSize || 10,
  });
  useTableUrlSync({ queryParams, page: pagination.page, pageSize: pagination.pageSize });
  const [isFetchAll, setFetchAll] = useState(false);
  // Ð§ÑÐ¾ ÑÐµÐ¹ÑÐ°Ñ Ð¾ÑÑÐ¸Ð»ÑÑÑÐ¾Ð²Ð°Ð½Ð¾: ÑÐ½Ð¸Ð¼Ð°ÐµÐ¼ Ð² Ð¼Ð¾Ð¼ÐµÐ½Ñ Â«ÐÐ°Ð¹ÑÐ¸Â», Ð° Ð½Ðµ ÑÐ¸ÑÐ°ÐµÐ¼ Ð¿Ð¾ÑÐ¾Ð¼ Ð¸Ð·
  // leadsOptions â ÑÐ¾ÑÐ¼Ð° Ð¿ÑÐ¸ Ð·Ð°ÐºÑÑÑÐ¸Ð¸ Ð¿Ð°Ð½ÐµÐ»Ð¸ ÑÐ°Ð·Ð¼Ð¾Ð½ÑÐ¸ÑÑÐµÑÑÑ Ð¸ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ Ð² Ð¾Ð¿ÑÐ¸ÑÑ
  // Ð·Ð°ÑÐ¸ÑÐ°ÑÑÑÑ, Ð° ÑÑÑÐ¾ÐºÐ° Ð½Ð°Ð´ ÑÐ°Ð±Ð»Ð¸ÑÐµÐ¹ Ð´Ð¾Ð»Ð¶Ð½Ð° Ð¾ÑÑÐ°Ð²Ð°ÑÑÑÑ.
  const [appliedFilters, setAppliedFilters] = useState([]);
  // Ref Ð½Ð° ÑÐ¾ÑÐ¼Ñ ÑÐ¸Ð»ÑÑÑÐ¾Ð²: ÑÐ½ÑÑÑÐ¹ ÑÐ¸Ð¿ Ð½Ð°Ð´Ð¾ ÑÐ±ÑÐ°ÑÑ Ð¸ Ð¸Ð· Ð·Ð°Ð¿ÑÐ¾ÑÐ°, Ð¸ Ð¸Ð· ÑÐ°Ð¼Ð¾Ð³Ð¾ ÑÐµÐ»ÐµÐºÑÐ°.
  // ÐÐµÑÐµÐ¼Ð¾Ð½ÑÐ¸ÑÐ¾Ð²Ð°ÑÑ ÑÐ¾ÑÐ¼Ñ, ÐºÐ°Ðº ÑÑÐ¾ Ð´ÐµÐ»Ð°ÐµÑ Â«Ð¡Ð±ÑÐ¾ÑÐ¸ÑÑÂ», ÑÑÑ Ð½ÐµÐ»ÑÐ·Ñ â Ð²Ð¼ÐµÑÑÐµ Ñ Ð¾Ð´Ð½Ð¸Ð¼
  // Ð·Ð½Ð°ÑÐµÐ½Ð¸ÐµÐ¼ Ð¾Ð±Ð½ÑÐ»Ð¸Ð»Ð¸ÑÑ Ð±Ñ Ð¸ Ð¾ÑÑÐ°Ð»ÑÐ½ÑÐµ.
  const filtersFormRef = React.useRef(null);
  const filtersTimer = React.useRef(null);
  const [showModal, setShowModal] = React.useState(false);

  const table = useTable(
    {
      columns,
      data: leads,
      initialState: {
        pageSize: pagination.pageSize,
      },
      manualPagination: true,
      pageCount: pagination.totalPages,
      page: pagination.page - 1,
      disableSortRemove: true,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const { setGlobalFilter, page, setPageSize } = table;

  const [value, setValue] = useState(fromUrl.filters.all || '');

  const record = [{ name: 'record', component: SelectManager, label: 'Ð¡ÑÐ°ÑÑÑ Ð·Ð°Ð¿Ð¸ÑÐ¸' }];
  const [currentLead, setCurrentLead] = useState(null);

  const handleNavigate = (index) => {
    navigate(`lead/${leads.find((item) => item.id === index).id}/main-info`, {
      state: leads.find((item) => item.id === index),
    });
  };

  const addLead = () => {
    navigate('/leads/create');
  };

  const getLeads = async (params) => {
    setLoading(true);
    await axios
      .get('/api/crm/leads/getLeads', { params: { ...params } })
      .then((res) => {
        setLeads(res.data.leads);
        setPagination({
          ...res.data.pagination,
          page: res.data.pagination?.pageNumber,
          pageSize: pagination.pageSize,
        });
        setDataCount(res.data.pagination?.count);
      })
      .catch((error) => {})
      .finally(() => setLoading(false));
  };

  React.useEffect(() => {
    if (!isFetchAll) {
      getLeads({ page: pagination.page, pageSize: pagination.pageSize, ...queryParams });
    }
  }, [pagination.page, pagination.pageSize, queryParams]);

  const applyFilters = (resetFilters) => {
    clearTimeout(filtersTimer.current);
    setFilters(resetFilters, setFetchAll, setPageSize, setPagination, setQueryParams, leadsOptions);
    setAppliedFilters(resetFilters ? [] : describeFilters(leadsOptions));

    if (resetFilters) {
      // ÐÐµÑÐ¾Ð»ÑÑ Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÐ½Ð¾: ÑÐ¾ÑÐ¼Ð° Ð¼Ð¾Ð½ÑÐ¸ÑÑÐµÑÑÑ Ð¸Ð· Ð½Ð¸Ñ, Ð¸ Ð²Ð¾ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð½ÑÐµ Ð¸Ð·
      // Ð°Ð´ÑÐµÑÐ° Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ Ð²ÐµÑÐ½ÑÐ»Ð¸ÑÑ Ð±Ñ Ð¿ÑÐ¸ ÑÐ»ÐµÐ´ÑÑÑÐµÐ¼ Ð¾ÑÐºÑÑÑÐ¸Ð¸ Ð¿Ð°Ð½ÐµÐ»Ð¸.
      leadsOptions.forEach((option) => delete option.defaultValue);
      clearFilterSnapshot(SNAPSHOT_KEY);
    } else {
      saveFilterSnapshot(SNAPSHOT_KEY, leadsOptions);
    }
  };

  // Ð¤Ð¸Ð»ÑÑÑÑ Ð¸Ð· Ð°Ð´ÑÐµÑÐ°: Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ¸ Ðº id Ð±ÐµÑÑÐ¼ Ð¸Ð· ÑÐ½Ð¸Ð¼ÐºÐ° Ð¿Ð¾ÑÐ»ÐµÐ´Ð½ÐµÐ³Ð¾ Ð¿ÑÐ¸Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ.
  React.useEffect(() => {
    const restored = readFilterValues(SNAPSHOT_KEY, fromUrl.filters);
    leadsOptions.forEach((option) => {
      const value = restored[option.name];
      if (value === undefined) return;
      option.value = value;
      option.defaultValue = value;
      filtersFormRef.current?.setValue(option.name, value);
    });
    setAppliedFilters(describeFilters(leadsOptions));
    // Ð¢Ð¾Ð»ÑÐºÐ¾ Ð½Ð° Ð¼Ð¾Ð½ÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ð¸: Ð´Ð°Ð»ÑÑÐµ Ð·Ð½Ð°ÑÐµÐ½Ð¸ÑÐ¼Ð¸ ÑÐ°ÑÐ¿Ð¾ÑÑÐ¶Ð°ÐµÑÑÑ ÑÐ¾ÑÐ¼Ð°.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Ð¤Ð¸Ð»ÑÑÑ Ð¿ÑÐ¸Ð¼ÐµÐ½ÑÐµÑÑÑ ÑÐ°Ð¼: Ð²ÑÐ±ÑÐ°Ð» Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ â ÑÐ¿Ð¸ÑÐ¾Ðº Ð¿ÐµÑÐµÑÑÑÐ¾Ð¸Ð»ÑÑ, Ð¶Ð°ÑÑ Â«ÐÐ°Ð¹ÑÐ¸Â»
  // Ð¿Ð¾ÑÐ»Ðµ ÐºÐ°Ð¶Ð´Ð¾Ð³Ð¾ Ð¿Ð¾Ð»Ñ Ð½Ðµ Ð½ÑÐ¶Ð½Ð¾. ÐÐ°Ð´ÐµÑÐ¶ÐºÐ° Ð¾Ð´Ð½Ð° Ð½Ð° Ð²ÑÐµ Ð¿Ð¾Ð»Ñ: Ð² ÑÐµÐºÑÑÐµ Ð¾Ð½Ð° Ð³Ð°ÑÐ¸Ñ
  // Ð·Ð°Ð¿ÑÐ¾Ñ Ð½Ð° ÐºÐ°Ð¶Ð´ÑÑ Ð±ÑÐºÐ²Ñ, Ð² ÑÐµÐ»ÐµÐºÑÐ°Ñ Ð¿ÑÐ¾ÑÑÐ¾ Ð½ÐµÐ·Ð°Ð¼ÐµÑÐ½Ð°. ÐÐ½Ð°ÑÐµÐ½Ð¸Ñ ÑÐ¸ÑÐ°ÐµÐ¼ Ð¸Ð·
  // leadsOptions â HookForm Ð´ÐµÑÐ¶Ð¸Ñ Ð¸Ñ ÑÐ°Ð¼ Ð² Ð°ÐºÑÑÐ°Ð»ÑÐ½Ð¾Ð¼ Ð²Ð¸Ð´Ðµ (item.value).
  const handleFiltersChange = React.useCallback(() => {
    clearTimeout(filtersTimer.current);
    filtersTimer.current = setTimeout(() => applyFilters(false), 400);
  }, []);

  React.useEffect(() => () => clearTimeout(filtersTimer.current), []);

  const removeFilter = (name) => {
    const option = leadsOptions.find((item) => item.name === name);
    if (option) {
      delete option.value;
      delete option.defaultValue;
    }
    // Ð¤Ð¾ÑÐ¼Ð° Ð¼Ð¾Ð¶ÐµÑ Ð±ÑÑÑ ÑÐ²ÑÑÐ½ÑÑÐ° â ÑÐ¾Ð³Ð´Ð° ÐµÑ ref Ð¿ÑÑÑÐ¾Ð¹, Ð¸ ÑÐ¸ÑÑÐ¸ÑÑ Ð² Ð½ÐµÐ¹ Ð½ÐµÑÐµÐ³Ð¾.
    filtersFormRef.current?.setValue(name, null);
    applyFilters(false);
  };

  const handleActionPopover = async (leadIndex, actionIndex, title, id) => {
    setCurrentLead(leadIndex);
    if (actionIndex === 0) {
      navigate(`lead/${leads[leadIndex].id}/main-info`, { state: leads[leadIndex] });
    }
    if (actionIndex === 1) {
      navigate(`lead/edit/${leads[leadIndex].id}`, { state: leads[leadIndex] });
    }
    if (actionIndex === 2) {
      setShowModal(true);
    }
    if (actionIndex === 3) {
      await axios
        .get('/api/crm/leads/deleteLead', { params: { leadId: leads[leadIndex].id } })
        .then((res) => {
          getLeads({ page: pagination.page, pageSize: pagination.pageSize, ...queryParams });
        })
        .catch((error) => {});
    }
  };

  const editLead = async (val) => {
    if (record[0]?.value?.value) {
      await axios
        .post('/api/crm/leads/editLead', { managerId: record[0]?.value?.value, id: leads[currentLead].id })
        .then((res) => {
          getLeads({ page: pagination.page, pageSize: pagination.pageSize, ...queryParams });
        })
        .finally(() => {
          setShowModal(false);
        });
    }
  };

  const [showClientPopup, setShowClientPopup] = React.useState(false);
  const [clientId, setClientId] = React.useState(null);

  const sortBy = (value) => {
    if (!sortLeadsParams.get(value)) return;
    if (sortLeadsParams.get(value) === queryParams.sortBy) {
      queryParams.sortBy = '';
    } else {
      queryParams.sortBy = sortLeadsParams.get(value);
    }
    setFetchAll(false);
    setQueryParams({ ...queryParams });
  };

  return (
    <>
      {showClientPopup && <ClientPopup isOpen={showClientPopup} setOpen={setShowClientPopup} clientId={clientId} />}
      <Header title="ÐÐ¸Ð´Ñ" icon={icon} />
      <br />
      <br />
      <br />
      <br />
      <TableTabs
        setFilter={setGlobalFilter}
        value={value}
        setValue={setValue}
        filterComponent={
          <HookForm
            ref={filtersFormRef}
            inputs={leadsOptions}
            onValuesChange={handleFiltersChange}
            grid={{
              display: 'grid',
              gap: '10px',
              gridTemplateColumns: '1fr 1fr 1fr 1fr',
            }}
            responsiveForm
            style={{ backgroundColor: 'transparent' }}
          />
        }
        defaultFiltersOpen={Object.keys(fromUrl.filters).some((name) => name !== 'all')}
        handleSearchParams={applyFilters}
        appliedFilters={appliedFilters}
        onRemoveFilter={removeFilter}
        navigate={addLead}
        button={'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð»Ð¸Ð´'}
        permission={PERMISSION_CAN_CREATE_LEADS}
        inputPlaceholder={'ÐÑÑÑÑÑÐ¹ Ð¿Ð¾Ð¸ÑÐº Ð¿Ð¾ Ð»Ð¸Ð´Ð°Ð¼'}
      />
      <br />
      {!page.length && !loading ? (
        <Empty />
      ) : (
        <div>
          <EditLeadModal
            isOpen={showModal}
            onClose={() => setShowModal(false)}
            title={'ÐÐ°Ð·Ð½Ð°ÑÐ¸ÑÑ Ð¾ÑÐ²ÐµÑÑÑÐ²ÐµÐ½Ð½Ð¾Ð³Ð¾ Ð»Ð¸Ð´ ID - ' + leads[currentLead]?.id}
            handleSubmit={editLead}
            inputs={record}
          />
          <Table
            setPageSize={(value) => {
              setPageSize(value);
            }}
            table={table}
            all={'Ð»Ð¸Ð´Ð¾Ð²'}
            style={tableStyle}
            popover={popover}
            handleNavigate={handleNavigate}
            handleActionPopover={handleActionPopover}
            pagination
            sort
            setPagination={setPagination}
            setFetchAll={setFetchAll}
            isFetchAll={isFetchAll}
            setData={setLeads}
            p={pagination}
            setClientId={setClientId}
            setOpenClientPopup={setShowClientPopup}
            loading={loading}
            setLoading={setLoading}
            columns={columns}
            setColumns={setColumns}
            columnsSettingsKey="records"
            queryParams={queryParams}
            api={'/api/crm/leads/getLeads'}
            response={'leads'}
            isSortable
            dataCount={dataCount}
            handleSortTable={sortBy}
          />
        </div>
      )}
    </>
  );
};

export default Leads;
